import type { QueryClient } from "@tanstack/react-query";

// Meal edits also change diary confirmation, archives, EA and coach context.
export function invalidateNutritionQueries(client: QueryClient) {
  return client.invalidateQueries({
    predicate: ({ queryKey }) => {
      const key = String(queryKey[0]);
      return key.startsWith("nutrition-") || key === "energy-availability"
        || key === "dashboard" || key === "coach-context";
    },
  });
}
